import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import GridColSettingConstants from "../Constants/GridColumn_SettingConstants";

class GridColumn_Setting_Actions {
  getColumnSetting(equipmentGroupId, reportCode) {
    httpRequest(
      config.webServiceURL +
        "/Setting/GetPageGridColumnSetting/" +
        equipmentGroupId +
        "/" +
        reportCode,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: GridColSettingConstants.GET_COL_SETTING_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: GridColSettingConstants.GET_COL_SETTING_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  saveGridColumnSetting(gridSettingData) {
    httpRequest(
      config.webServiceURL + "/Setting/SaveOrUpdatePageGridColumnSetting",
      "POST",
      JSON.stringify({
        ReportCode: gridSettingData.ReportCode,
        EquipmentGroupId: gridSettingData.EquipmentGroupId,
        GridColumns: gridSettingData.GridColumns,
      }),
      (res, message) => {
        if (res !== "Error") {
          switch (gridSettingData.ReportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_NIO_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (gridSettingData.ReportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_FAILURE,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_OVERDUE_FAILURE,
                result: message,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_NIO_FAILURE,
                result: message,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE,
                result: message,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_FAILURE,
                result: message,
              });
              break;
          }
        }
      }
    );
  }
  getSaveFilterList(equipmentGroupId, reportCode) {
    httpRequest(
      config.webServiceURL +
        "/UserPageSetting/GetUserPageSettings/" +
        equipmentGroupId +
        "/" +
        reportCode +
        "/" +
        "Filter",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE,
                result: message,
              });
              break;

            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_OVERDUE_FAILURE,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_FAILURE,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_FAILURE,
                result: res,
              });
              break;
          }
        }
      }
    );
  }

  saveFilterGrid(gridSettingData) {
    const object =
      gridSettingData.ID === null
        ? {
            Title: gridSettingData.Title,
            EquipmentGroupId: gridSettingData.eqgID,
            ReportCode: gridSettingData.ReportCode,
            SettingType: gridSettingData.SettingType,
            SettingValue: gridSettingData.SettingValue,
          }
        : {
            ID: gridSettingData.ID,
            Title: gridSettingData.Title,
            EquipmentGroupId: gridSettingData.eqgID,
            ReportCode: gridSettingData.ReportCode,
            SettingType: gridSettingData.SettingType,
            SettingValue: gridSettingData.SettingValue,
          };
    httpRequest(
      config.webServiceURL + "/UserPageSetting/SaveOrUpdateUserPageSetting",
      "POST",
      JSON.stringify(object),
      (res, message) => {
        if (res !== "Error") {
          switch (gridSettingData.ReportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_NIO_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (gridSettingData.ReportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_OVERDUE_FAILURE,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_NIO_FAILURE,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_FAILURE,
                result: res,
              });
              break;
          }
        }
      }
    );
  }

  getSaveFilterValue(userPageSettingId, ReportId) {
    httpRequest(
      config.webServiceURL +
        "/UserPageSetting/GetUserPageSetting/" +
        userPageSettingId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          switch (ReportId) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_NIO_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (userPageSettingId.ReportId) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE,
                result: message,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE,
                result: message,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_NIO_FAILURE,
                result: message,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE,
                result: message,
              });
              break;
          }
        }
      }
    );
  }

  getEquipmentListOnFilter(userPageSettingValue) {
    httpRequest(
      config.webServiceURL + "/PEGrid/ProcessFilterRequest/",
      "POST",
      JSON.stringify({
        FilterId: userPageSettingValue.FilterId,
        EquipmentGroupId: userPageSettingValue.EquipmentGroupId,
        ReportId: userPageSettingValue.ReportId,
        PageSize: userPageSettingValue.PageSize,
      }),
      (res, message) => {
        if (res !== "Error") {
          switch (userPageSettingValue.ReportId) {
            case "EquipList":
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_FILTER_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_NIO_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (userPageSettingValue.ReportId) {
            case "EquipList":
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_FILTER_FAILURE,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_OVERDUE_FAILURE,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_NIO_FAILURE,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_FAILURE,
                result: res,
              });
              break;
          }
        }
      }
    );
  }

  deleteSavedFilter(filterId, reportCode) {
    httpRequest(
      config.webServiceURL + "/UserPageSetting/" + filterId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.DEL_SAVED_FILTER_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: GridColSettingConstants.DEL_SAVED_FILTER__FAILURE,
                result: message,
              });
              break;
          }
        }
      }
    );
  }
}

export default new GridColumn_Setting_Actions();
